webpackJsonp([47],{

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationForm_vue__ = __webpack_require__(705);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16dff799_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationForm_vue__ = __webpack_require__(837);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16dff799_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(468));

var _alphaNum = _interopRequireDefault(__webpack_require__(471));

var _numeric = _interopRequireDefault(__webpack_require__(472));

var _between = _interopRequireDefault(__webpack_require__(473));

var _email = _interopRequireDefault(__webpack_require__(474));

var _ipAddress = _interopRequireDefault(__webpack_require__(475));

var _macAddress = _interopRequireDefault(__webpack_require__(476));

var _maxLength = _interopRequireDefault(__webpack_require__(477));

var _minLength = _interopRequireDefault(__webpack_require__(478));

var _required = _interopRequireDefault(__webpack_require__(479));

var _requiredIf = _interopRequireDefault(__webpack_require__(480));

var _requiredUnless = _interopRequireDefault(__webpack_require__(481));

var _sameAs = _interopRequireDefault(__webpack_require__(482));

var _url = _interopRequireDefault(__webpack_require__(483));

var _or = _interopRequireDefault(__webpack_require__(484));

var _and = _interopRequireDefault(__webpack_require__(485));

var _not = _interopRequireDefault(__webpack_require__(486));

var _minValue = _interopRequireDefault(__webpack_require__(487));

var _maxValue = _interopRequireDefault(__webpack_require__(488));

var _integer = _interopRequireDefault(__webpack_require__(489));

var _decimal = _interopRequireDefault(__webpack_require__(490));

var helpers = _interopRequireWildcard(__webpack_require__(465));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(470).withParams : __webpack_require__(235).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/countryPhones';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/shop/availabilities';

/* harmony default export */ __webpack_exports__["a"] = ({
  searchVehicleRental: function searchVehicleRental(request) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/rental', request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  searchVehicleAirport: function searchVehicleAirport(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/airport', request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  selectVehicle: function selectVehicle(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/vehicle', request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  loadBookingForm: function loadBookingForm(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/form', request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 627:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/shop/reservations';

/* harmony default export */ __webpack_exports__["a"] = ({
  getById: function getById(id) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/' + id)).then(function (response) {
                return response.data.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/create', request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  confirm: function confirm(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/confirm', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  cancel: function cancel(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/cancel', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_shop_availability_instantAvailabilityService_js__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_shop_reservation_instantReservationService_js__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_master_countryPhoneService_js__ = __webpack_require__(532);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import numeral from "numeral";



// import maverickMap from "@/plugins/google/map.js";
// import maverickGeocoding from "@/plugins/google/geocode.js";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      reservationRequest: {
        correlationId: null,
        serviceType: null,
        vehicleId: null,
        providerId: null,
        departureAirline: null,
        departureFlightNumber: null,
        notes: "",
        booker: {
          companyId: null,
          customerId: null,
          freetext: {
            title: "Mr",
            fullName: null,
            email: null,
            phoneCode: null,
            phoneNumber: null
          }
        },
        passengers: [{
          companyId: null,
          customerId: null,
          title: "Mr",
          fullName: null,
          email: null,
          phoneCode: null,
          phoneNumber: null
        }],
        ancillaries: []
      },
      isSubmitted: false,
      isSelfDrive: false,
      isPassengerSameAsBooker: false,
      moneyFormat: null,
      vehicle: null,
      totalAncillary: 0,
      ancillaries: [],
      rentDays: null,
      items: [],
      airlines: [],
      selectedAncillaries: [],
      companies: [],
      customersAsBooker: [],
      customersAsPassenger: [],
      phoneCodes: [],
      isLoading: false,
      searchParameter: { mode: "" },
      personTitles: [{ value: "Mr", text: "Mr" }, { value: "Mrs", text: "Mrs" }, { value: "Ms", text: "Ms" }],
      msg: "Please wait",
      userProfile: {},
      useCompanySelection: true,
      useCustomerSelection: true
    };
  },
  validations: function validations() {
    var v = {
      reservationRequest: {
        booker: {
          companyId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
          customerId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
        },
        passengers: {
          $each: {
            companyId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
            customerId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
          }
        },
        departureAirline: this.validationDepartureAirline,
        departureFlightNumber: this.validationDepartureFlightNumber,
        notes: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(400) }
      }
    };

    if (this.isUseFreetext(this.reservationRequest.booker.customerId)) {
      v.reservationRequest.booker.freetext = {
        title: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        fullName: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        email: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"] },
        phoneCode: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        phoneNumber: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
      };
    }

    if (this.isUseFreetext(this.reservationRequest.passengers[0].customerId)) {
      v.reservationRequest.passengers.$each = {
        companyId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        customerId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        title: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        fullName: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        email: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"] },
        phoneCode: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        phoneNumber: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
      };
    }

    return v;
  },

  computed: {
    searchParameterPickUpLocation: function searchParameterPickUpLocation() {
      return this.searchParameter.pickUpLocation !== undefined ? this.searchParameter.pickUpLocation.name : "";
    },
    searchParameterDropOffLocation: function searchParameterDropOffLocation() {
      return this.searchParameter.dropOffLocation !== undefined && this.searchParameter.dropOffLocation !== null ? this.searchParameter.dropOffLocation.name : "Same Location";
    },
    pickUpOtherLocationName: function pickUpOtherLocationName() {
      return this.pickUpOtherLocation !== null ? this.pickUpOtherLocation.name : "";
    },
    dropOffOtherLocationName: function dropOffOtherLocationName() {
      return this.dropOffOtherLocation !== null ? this.dropOffOtherLocation.name : "";
    },
    pickUpOtherLocationRate: function pickUpOtherLocationRate() {
      return this.pickUpOtherLocation !== null ? this.pickUpOtherLocation.rate : "Select Location by Map";
    },
    dropOffOtherLocationRate: function dropOffOtherLocationRate() {
      return this.dropOffOtherLocation !== null ? this.dropOffOtherLocation.rate : "Select Location by Map";
    },
    shortPickUpDate: function shortPickUpDate() {
      return this.$helper.toDateString(this.searchParameter.pickUpDate, "D MMM");
    },
    shortPickUpTime: function shortPickUpTime() {
      return this.$helper.toDateString(this.searchParameter.pickUpDate, "HH:mm");
    },
    shortDropOffDate: function shortDropOffDate() {
      return this.$helper.toDateString(this.searchParameter.dropOffDate, "D MMM");
    },
    shortDropOffTime: function shortDropOffTime() {
      return this.$helper.toDateString(this.searchParameter.dropOffDate, "HH:mm");
    },
    isAirportTransfer: function isAirportTransfer() {
      return this.searchParameter && this.searchParameter.serviceType && this.searchParameter.serviceType === "AirportTransfer";
    },
    hasAncillary: function hasAncillary() {
      return this.ancillaries && this.ancillaries.length > 0;
    },
    isAncillarySelected: function isAncillarySelected() {
      return this.hasAncillary && this.selectedAncillaries.length > 0;
    },
    hasSurcharge: function hasSurcharge() {
      return this.vehicle && this.vehicle.surcharge > 0;
    },
    hasPaxCapacity: function hasPaxCapacity() {
      return this.vehicle.feature && this.vehicle.feature.paxCapacity && parseInt(this.vehicle.feature.paxCapacity) > 0;
    },
    hasLargeBaggageCapacity: function hasLargeBaggageCapacity() {
      return this.vehicle.feature && this.vehicle.feature.largeBaggageCapacity && parseInt(this.vehicle.feature.largeBaggageCapacity) > 0;
    },
    hasSmallBaggageCapacity: function hasSmallBaggageCapacity() {
      return this.vehicle.feature && this.vehicle.feature.smallBaggageCapacity && parseInt(this.vehicle.feature.smallBaggageCapacity) > 0;
    },
    hasVehicleName: function hasVehicleName() {
      return this.vehicle.factoryName && this.factoryName !== "" || this.vehicle.brandName && this.vehicle.brandName !== "";
    },
    totalInsurance: function totalInsurance() {
      var total = 0;
      if (this.isSelfDrive && this.vehicle.selfDriveRate && this.vehicle.selfDriveRate.items) {
        total = this.vehicle.selfDriveRate.items.reduce(function (a, b) {
          return a + b.rate;
        }, 0);
      }
      return total;
    },
    grandTotal: function grandTotal() {
      var total = 0;
      if (this.vehicle) {
        total += this.vehicle.baseFare + this.vehicle.surcharge + this.totalAncillary;
      }
      total += this.totalInsurance;
      return total;
    },
    orderedAirlines: function orderedAirlines() {
      var airlines = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.airlines, "iataCode");
      for (var index = 0; index < airlines.length; index++) {
        var airline = airlines[index];
        airline.label = "(" + airline.iataCode + ") " + airline.name;
      }
      return airlines;
    },
    validationDepartureAirline: function validationDepartureAirline() {
      return this.isAirportTransfer ? { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] } : {};
    },
    validationDepartureFlightNumber: function validationDepartureFlightNumber() {
      return this.isAirportTransfer ? { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(4) } : {};
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _this.isLoading = true;
              _context.next = 4;
              return _this.getBookingInfo();

            case 4:
              _context.next = 6;
              return _this.getPhoneCodes();

            case 6:
              _context.next = 8;
              return _this.$store.dispatch("user/getProfile");

            case 8:
              _this.userProfile = _context.sent;

              _this.setupForm();

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    // if (!this.map) {
    //   // creates map instance
    //   this.map = new maverickMap({
    //     mapId: "map",
    //     lat: -6.17003832454938,
    //     lng: 106.81490242481232,
    //     marker: true,
    //     autocomplete: true,
    //     confirmLocationCallback: this.confirmLocation,
    //     removeLocationCallback: this.removeLocation,
    //     autoCompleteGetPlaceCallback: this.getPlace,
    //     markerChangeCallback: this.markerChange,
    //   });
    //   this.map.initialize();
    // }
    // if (!this.geocoder) {
    //   // creates geocoder instance
    //   this.geocoder = new maverickGeocoding();
    // }
  },
  updated: function updated() {
    this.$helper.alphabetsOnly();
    this.$helper.numbersOnly();
    this.$helper.alphabetsNumbersOnly();

    // setTimeout(() => {
    //   $("#RefreshConfirmation").modal({ backdrop: "static", keyboard: false });
    // }, this.$helper.fromMinutestoMilliseconds(30));
  },

  methods: {
    setupForm: function setupForm() {
      var _this2 = this;

      if (this.userProfile.selectors && this.userProfile.selectors["Companies"]) {
        var userCompany = this.companies.find(function (company) {
          return company.id == _this2.userProfile.selectors["Companies"].defaultId;
        });

        if (userCompany) {
          this.reservationRequest.booker.companyId = userCompany.id;
          this.getBookersByCompanyId(userCompany.id);

          var userCustomer = userCompany.customers.find(function (cust) {
            return cust.id == _this2.userProfile.id;
          });

          if (userCustomer) {
            this.reservationRequest.booker.customerId = userCustomer.id;
          }
        }
      } else {
        this.useCompanySelection = false;
        this.useCustomerSelection = false;
        this.reservationRequest.booker.companyId = this.$helper.emptyGuid();
        this.reservationRequest.booker.customerId = this.$helper.emptyGuid();
        this.reservationRequest.passengers[0].companyId = this.$helper.emptyGuid();
        this.reservationRequest.passengers[0].customerId = this.$helper.emptyGuid();
      }
    },
    onChangeAncillary: function onChangeAncillary(ancillary) {
      this.totalAncillary = 0;
      this.selectedAncillaries = this.ancillaries.filter(function (x) {
        return x.quantity && parseInt(x.quantity) > 0;
      });
      for (var i = 0; i < this.selectedAncillaries.length; i++) {
        var item = this.selectedAncillaries[i];
        item.subtotal = item.rate * parseInt(item.quantity);
        this.totalAncillary += item.subtotal;
      }
    },
    onBlurAncillary: function onBlurAncillary(item) {
      if (item.quantity === "") {
        item.quantity = 0;
      }
    },
    isUseFreetext: function isUseFreetext(customerId) {
      return customerId === this.$helper.emptyGuid();
    },
    getBookersByCompanyId: function getBookersByCompanyId(companyId) {
      var freetextValue = {
        companyId: companyId,
        emails: [],
        fullName: "Free Text",
        label: "Free Text",
        gender: null,
        id: this.$helper.emptyGuid(),
        phones: [],
        title: null
      };

      this.customersAsBooker = this.companies.flatMap(function (x) {
        return x.customers;
      }).filter(function (x) {
        return x.companyId === companyId;
      });

      this.customersAsBooker = this.$helper.prependToArray(freetextValue, this.customersAsBooker);

      this.reservationRequest.booker.customerId = null;
      this.reservationRequest.passengers[0].customerId = null;
      if (this.isPassengerSameAsBooker) {
        this.reservationRequest.passengers[0].companyId = companyId;
      } else {
        this.customersAsPassenger = [];
        this.reservationRequest.passengers[0].companyId = null;
      }
    },
    getPassengersByCompanyId: function getPassengersByCompanyId(companyId) {
      var freetextValue = {
        companyId: companyId,
        emails: [],
        fullName: "Free Text",
        label: "Free Text",
        gender: null,
        id: this.$helper.emptyGuid(),
        phones: [],
        title: null
      };

      this.customersAsPassenger = this.companies.flatMap(function (x) {
        return x.customers;
      }).filter(function (x) {
        return x.companyId === companyId;
      });

      this.customersAsPassenger = this.$helper.prependToArray(freetextValue, this.customersAsPassenger);

      this.reservationRequest.passengers[0].customerId = null;
    },
    onChangeBooker: function onChangeBooker(item) {
      if (this.isPassengerSameAsBooker) {
        this.customersAsPassenger = this.customersAsBooker;
        this.reservationRequest.passengers[0].customerId = item;
      } else {
        this.reservationRequest.passengers[0].companyId = null;
        this.reservationRequest.passengers[0].customerId = null;
      }
    },
    printMoney: function printMoney(value) {
      return this.moneyFormat ? __WEBPACK_IMPORTED_MODULE_2_numeral___default()(value).format(this.moneyFormat.decimalFormat) : value;
    },
    refresh: function refresh() {
      var queryParam = {};
      switch (this.searchParameter.serviceType.toLocaleLowerCase()) {
        case "airporttransfer":
          // pick-up
          queryParam.plt = this.searchParameter.pickUpLocation.latitude;
          queryParam.plg = this.searchParameter.pickUpLocation.longitude;
          queryParam.pcd = this.searchParameter.pickUpLocation.code;
          queryParam.pad = this.searchParameter.pickUpLocation.address;
          queryParam.pnm = this.searchParameter.pickUpLocation.name;
          queryParam.pcn = this.searchParameter.pickUpLocation.country;

          // drop-off
          queryParam.dlt = this.searchParameter.dropOffLocation.latitude;
          queryParam.dlg = this.searchParameter.dropOffLocation.longitude;
          queryParam.dcd = this.searchParameter.dropOffLocation.code;
          queryParam.dad = this.searchParameter.dropOffLocation.address;
          queryParam.dnm = this.searchParameter.dropOffLocation.name;
          queryParam.dcn = this.searchParameter.dropOffLocation.country;

          // start rent
          queryParam.ptm = this.searchParameter.pickUpDate.year + "." + this.searchParameter.pickUpDate.month + "." + this.searchParameter.pickUpDate.day + "-" + this.searchParameter.pickUpDate.hour + "." + this.searchParameter.pickUpDate.minute;

          // service type
          queryParam.svc = "airporttransfer";
          break;
        case "rental":
          // pick-up location (coordinate & address)
          queryParam.plt = this.searchParameter.pickUpLocation.latitude;
          queryParam.plg = this.searchParameter.pickUpLocation.longitude;
          queryParam.pad = this.searchParameter.pickUpLocation.address;
          queryParam.pnm = this.searchParameter.pickUpLocation.name;
          queryParam.pcn = this.searchParameter.pickUpLocation.country;

          // start rent
          queryParam.str = this.searchParameter.pickUpDate.year + "." + this.searchParameter.pickUpDate.month + "." + this.searchParameter.pickUpDate.day + "-" + this.searchParameter.pickUpDate.hour + "." + this.searchParameter.pickUpDate.minute;

          // end rent
          queryParam.enr = this.searchParameter.dropOffDate.year + "." + this.searchParameter.dropOffDate.month + "." + this.searchParameter.dropOffDate.day + "-" + this.searchParameter.dropOffDate.hour + "." + this.searchParameter.dropOffDate.minute;

          // with driver / self drive
          queryParam.slf = this.isSelfDrive;

          // service type
          queryParam.svc = "rental";
          break;
      }
      queryParam.mode = this.searchParameter.mode;
      // HACK: handle duplication routing
      queryParam.ver = Math.random().toString(36).substr(2, 9);
      this.$router.push({ path: "/availability/instant", query: queryParam });
    },
    copyBooker: function copyBooker() {
      var _this3 = this;

      if (this.isPassengerSameAsBooker) {
        if (this.reservationRequest.booker.companyId != this.reservationRequest.passengers[0].companyId) {
          this.getPassengersByCompanyId(this.reservationRequest.booker.companyId);
        }
        this.$nextTick(function () {
          _this3.reservationRequest.passengers[0].companyId = _this3.reservationRequest.booker.companyId;
          _this3.reservationRequest.passengers[0].customerId = _this3.reservationRequest.booker.customerId;
          _this3.reservationRequest.passengers[0].title = _this3.reservationRequest.booker.freetext.title;
          _this3.reservationRequest.passengers[0].fullName = _this3.reservationRequest.booker.freetext.fullName;
          _this3.reservationRequest.passengers[0].phoneCode = _this3.reservationRequest.booker.freetext.phoneCode;
          _this3.reservationRequest.passengers[0].phoneNumber = _this3.reservationRequest.booker.freetext.phoneNumber;
          _this3.reservationRequest.passengers[0].email = _this3.reservationRequest.booker.freetext.email;
        });
      } else {
        if (this.useCompanySelection && this.useCustomerSelection) {
          this.reservationRequest.passengers[0].companyId = null;
          this.reservationRequest.passengers[0].customerId = null;
        } else {
          this.reservationRequest.passengers[0].companyId = this.$helper.emptyGuid();
          this.reservationRequest.passengers[0].customerId = this.$helper.emptyGuid();
        }

        this.reservationRequest.passengers[0].title = null;
        this.reservationRequest.passengers[0].fullName = null;
        this.reservationRequest.passengers[0].phoneCode = null;
        this.reservationRequest.passengers[0].phoneNumber = null;
        this.reservationRequest.passengers[0].email = null;
      }
    },
    constructPayload: function constructPayload() {
      var payload = {
        serviceType: this.searchParameter.serviceType,
        correlationId: this.reservationRequest.correlationId,
        selectorId: this.reservationRequest.selectorId,
        departureAirline: this.isAirportTransfer ? this.reservationRequest.departureAirline.toUpperCase() : null,
        departureFlightNumber: this.reservationRequest.departureFlightNumber,
        notes: this.reservationRequest.notes,
        booker: {
          companyId: this.reservationRequest.booker.companyId,
          customerId: this.reservationRequest.booker.customerId
        },
        passengers: [{
          companyId: this.reservationRequest.passengers[0].companyId,
          customerId: this.reservationRequest.passengers[0].customerId
        }],
        ancillaries: []
      };

      if (this.isUseFreetext(payload.booker.customerId)) {
        payload.booker.freetext = this.reservationRequest.booker.freetext;
      }

      if (this.isUseFreetext(payload.passengers[0].customerId)) {
        payload.passengers[0].freetext = {
          title: this.reservationRequest.passengers[0].title,
          fullName: this.reservationRequest.passengers[0].fullName,
          email: this.reservationRequest.passengers[0].email,
          phoneCode: this.reservationRequest.passengers[0].phoneCode,
          phoneNumber: this.reservationRequest.passengers[0].phoneNumber
        };
      }

      var overrideBookerWithFreetext = payload.booker.companyId === this.$helper.emptyGuid() && payload.booker.customerId === this.$helper.emptyGuid();
      var overridePaxWithFreetext = payload.passengers[0].companyId === this.$helper.emptyGuid() && payload.passengers[0].customerId === this.$helper.emptyGuid();

      if (overrideBookerWithFreetext) {
        payload.booker = {
          freetext: this.reservationRequest.booker.freetext
        };
      }

      if (overridePaxWithFreetext) {
        payload.passengers[0] = {
          freetext: {
            title: this.reservationRequest.passengers[0].title,
            fullName: this.reservationRequest.passengers[0].fullName,
            email: this.reservationRequest.passengers[0].email,
            phoneCode: this.reservationRequest.passengers[0].phoneCode,
            phoneNumber: this.reservationRequest.passengers[0].phoneNumber
          }
        };
      }

      if (this.selectedAncillaries && this.selectedAncillaries.length > 0) {
        payload.ancillaries = this.selectedAncillaries.map(function (ancillary) {
          return {
            id: ancillary.id,
            quantity: parseInt(ancillary.quantity)
          };
        });
      }

      return payload;
    },
    getPhoneCodes: function getPhoneCodes() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var i, item;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_countryPhoneService_js__["a" /* default */].getAll();

              case 2:
                _this4.phoneCodes = _context2.sent;

                for (i = 0; i < _this4.phoneCodes.length; i++) {
                  item = _this4.phoneCodes[i];

                  item.label = item.iata + " (+" + item.dial + ")";
                  item.icon = "iti-flag " + item.iata.toLowerCase();
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    getBookingInfo: function getBookingInfo() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, i, ancillary, _i, company, j, customer;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this5.isLoading = true;

                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_shop_availability_instantAvailabilityService_js__["a" /* default */].loadBookingForm({
                  correlationId: _this5.$route.params.id
                });

              case 4:
                response = _context3.sent;


                _this5.reservationRequest.correlationId = _this5.$route.params.id;
                _this5.reservationRequest.serviceType = response.queryCache.serviceType;
                _this5.reservationRequest.selectorId = response.queryCache.data.selectorId;
                _this5.reservationRequest.selfDriveRateType = response.queryCache.selfDriveRateType;
                _this5.moneyFormat = response.queryCache.moneyFormat;
                _this5.searchParameter = {
                  dropOffDate: response.queryCache.dropOffDate,
                  dropOffLocation: response.queryCache.dropOffLocation,
                  serviceType: response.queryCache.serviceType,
                  pickUpDate: response.queryCache.pickUpDate,
                  pickUpLocation: response.queryCache.pickUpLocation,
                  mode: response.queryCache.mode
                };
                _this5.isSelfDrive = response.queryCache.isSelfDrive;
                _this5.rentDays = response.queryCache.rentDays;
                _this5.vehicle = response.queryCache.data;
                _this5.ancillaries = response.queryCache.data.ancillaries;
                _this5.airlines = response.airlines;
                _this5.companies = response.companies;

                if (_this5.ancillaries && _this5.ancillaries.length > 0) {
                  for (i = 0; i < _this5.ancillaries.length; i++) {
                    ancillary = _this5.ancillaries[i];

                    _this5.reservationRequest.ancillaries.push({ quantity: 0 });
                  }
                }

                for (_i = 0; _i < _this5.companies.length; _i++) {
                  company = _this5.companies[_i];

                  for (j = 0; j < company.customers.length; j++) {
                    customer = company.customers[j];

                    customer.label = customer.title + ". " + customer.fullName;
                  }
                }
                _context3.next = 25;
                break;

              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3["catch"](0);

                _this5.$helper.redirectToServerError(_this5);
                return _context3.abrupt("return");

              case 25:
                _context3.prev = 25;

                _this5.isLoading = false;
                return _context3.finish(25);

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 21, 25, 28]]);
      }))();
    },
    validateDoubleBook: function validateDoubleBook() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.isSubmitted = true;
                _this6.$v.reservationRequest.$touch();

                if (!_this6.$v.reservationRequest.$error) {
                  _context4.next = 5;
                  break;
                }

                _this6.$nextTick(function () {
                  return _this6.$helper.focusToFieldError();
                });
                return _context4.abrupt("return");

              case 5:
                _context4.prev = 5;

                _this6.isLoading = true;

                // const request = {
                //   mainPassenger: this.reservationRequest.passengers[0],
                //   correlationId: this.reservationRequest.correlationId,
                // };
                // const response = await inquiryReservationService.validateDoubleBook(request);
                // if (response && response.isExist) {
                //   $("#DoubleBookConfirmation").modal({ backdrop: "static", keyboard: false });
                //   return;
                // }
                _context4.next = 9;
                return _this6.bookNow();

              case 9:
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](5);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this6.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 14:
                _context4.prev = 14;

                _this6.isLoading = false;
                return _context4.finish(14);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[5, 11, 14, 17]]);
      }))();
    },
    bookNow: function bookNow() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var payload, reservationNumber, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this7.isLoading = true;

                payload = _this7.constructPayload();
                _context5.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__services_shop_reservation_instantReservationService_js__["a" /* default */].create(payload);

              case 5:
                reservationNumber = _context5.sent;


                // book success, then redirects to reservation page
                _this7.$router.push({
                  path: "/reservation/instant/" + reservationNumber
                });
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this7.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context5.prev = 12;

                _this7.isLoading = false;
                return _context5.finish(12);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[0, 9, 12, 15]]);
      }))();
    }
  }
});

/***/ }),

/***/ 837:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoading)?_c('section',{staticClass:"reservation-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-sm-offset-1"},[_c('div',{attrs:{"id":"form-contact"}},[(_vm.$v.reservationRequest.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n              This form has errors\n            ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validateDoubleBook($event)}}},[_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.useCompanySelection)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Company")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.reservationRequest.booker.companyId.$error,
                        },attrs:{"placeholder":"","label":"name","options":_vm.companies,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; }},on:{"input":_vm.getBookersByCompanyId},model:{value:(_vm.reservationRequest.booker.companyId),callback:function ($$v) {_vm.$set(_vm.reservationRequest.booker, "companyId", $$v)},expression:"reservationRequest.booker.companyId"}}),_vm._v(" "),(
                          _vm.isSubmitted &&
                          !_vm.$v.reservationRequest.booker.companyId.required
                        )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                        Company is required\n                      ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.useCustomerSelection)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Customer")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.reservationRequest.booker.customerId.$error,
                        },attrs:{"placeholder":"","label":"label","options":_vm.customersAsBooker,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; },"disabled":!_vm.reservationRequest.booker.companyId},on:{"input":_vm.onChangeBooker},model:{value:(_vm.reservationRequest.booker.customerId),callback:function ($$v) {_vm.$set(_vm.reservationRequest.booker, "customerId", $$v)},expression:"reservationRequest.booker.customerId"}}),_vm._v(" "),(
                          _vm.isSubmitted &&
                          !_vm.$v.reservationRequest.booker.customerId.required
                        )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                        Customer is required\n                      ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(
                        _vm.reservationRequest.booker.customerId &&
                        _vm.isUseFreetext(_vm.reservationRequest.booker.customerId)
                      )?[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Select Title")]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},_vm._l((_vm.personTitles),function(item,index){return _c('label',{key:index,staticClass:"btn",class:{
                              active:
                                _vm.reservationRequest.booker.freetext.title ===
                                item.value,
                            },on:{"click":function($event){_vm.reservationRequest.booker.freetext.title =
                                item.value}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.reservationRequest.booker.freetext.title
                              ),expression:"\n                                reservationRequest.booker.freetext.title\n                              "}],attrs:{"type":"radio","name":"booker_title","autocomplete":"off"},domProps:{"value":item.value,"checked":_vm.reservationRequest.booker.freetext.title ===
                                item.value,"checked":_vm._q(
                                _vm.reservationRequest.booker.freetext.title
                              ,item.value)},on:{"change":function($event){return _vm.$set(_vm.reservationRequest.booker.freetext, "title", item.value)}}}),_vm._v("\n                            "+_vm._s(item.text)+"\n                          ")])}),0),_vm._v(" "),(
                            _vm.isSubmitted &&
                            !_vm.$v.reservationRequest.booker.freetext.title
                              .required
                          )?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                          Title is required\n                        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Full Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(
                            _vm.reservationRequest.booker.freetext.fullName
                          ),expression:"\n                            reservationRequest.booker.freetext.fullName\n                          "}],staticClass:"form-control alphabets-only",class:{
                            'field-error':
                              _vm.isSubmitted &&
                              !_vm.$v.reservationRequest.booker.freetext.fullName
                                .required,
                          },attrs:{"type":"text","maxlength":"150"},domProps:{"value":(
                            _vm.reservationRequest.booker.freetext.fullName
                          )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reservationRequest.booker.freetext, "fullName", $event.target.value)}}}),_vm._v(" "),(
                            _vm.isSubmitted &&
                            !_vm.$v.reservationRequest.booker.freetext.fullName
                              .required
                          )?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                          Fullname is required\n                        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Phone")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                                'field-error':
                                  _vm.isSubmitted &&
                                  !_vm.$v.reservationRequest.booker.freetext
                                    .phoneCode.required,
                              },attrs:{"placeholder":"","label":"label","options":_vm.phoneCodes,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.dial; }},scopedSlots:_vm._u([{key:"search",fn:function(ref){
                              var attributes = ref.attributes;
                              var events = ref.events;
return [_c('input',_vm._g(_vm._b({staticClass:"vs__search",attrs:{"name":"booker_phoneCode"}},'input',attributes,false),events))]}},{key:"option",fn:function(option){return [_c('div',{staticClass:"phone-wrapper"},[_c('div',{staticClass:"phone-icon",class:option.icon}),_vm._v(" "),_c('div',{staticClass:"phone-text"},[_vm._v("\n                                    "+_vm._s(option.iata)+"\n                                  ")])])]}}],null,false,553913263),model:{value:(
                                _vm.reservationRequest.booker.freetext.phoneCode
                              ),callback:function ($$v) {_vm.$set(_vm.reservationRequest.booker.freetext, "phoneCode", $$v)},expression:"\n                                reservationRequest.booker.freetext.phoneCode\n                              "}}),_vm._v(" "),(
                                _vm.isSubmitted &&
                                !_vm.$v.reservationRequest.booker.freetext
                                  .phoneCode.required
                              )?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                              Phone code is required\n                            ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-8",staticStyle:{"padding-left":"0","padding-top":"30px"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.reservationRequest.booker.freetext.phoneNumber
                              ),expression:"\n                                reservationRequest.booker.freetext.phoneNumber\n                              "}],staticClass:"form-control numbers-only",class:{
                                'field-error':
                                  _vm.isSubmitted &&
                                  !_vm.$v.reservationRequest.booker.freetext
                                    .phoneNumber.required,
                              },attrs:{"type":"text","name":"booker_phoneNumber"},domProps:{"value":(
                                _vm.reservationRequest.booker.freetext.phoneNumber
                              )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reservationRequest.booker.freetext, "phoneNumber", $event.target.value)}}}),_vm._v(" "),(
                                _vm.isSubmitted &&
                                !_vm.$v.reservationRequest.booker.freetext
                                  .phoneNumber.required
                              )?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                              Phone number is required\n                            ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reservationRequest.booker.freetext.email),expression:"reservationRequest.booker.freetext.email"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted &&
                              !_vm.$v.reservationRequest.booker.freetext.email
                                .required,
                          },attrs:{"placeholder":"e.g youremail@gmail.com","maxlength":"100"},domProps:{"value":(_vm.reservationRequest.booker.freetext.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reservationRequest.booker.freetext, "email", $event.target.value)}}}),_vm._v(" "),(
                            _vm.isSubmitted &&
                            !_vm.$v.reservationRequest.booker.freetext.email
                              .required
                          )?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                          Email is required\n                        ")]):_vm._e(),_vm._v(" "),(
                            _vm.isSubmitted &&
                            _vm.$v.reservationRequest.booker.freetext.email
                              .required &&
                            !_vm.$v.reservationRequest.booker.freetext.email.email
                          )?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                          Email is invalid\n                        ")]):_vm._e()])]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"passenger-information"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isPassengerSameAsBooker),expression:"isPassengerSameAsBooker"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isPassengerSameAsBooker)?_vm._i(_vm.isPassengerSameAsBooker,null)>-1:(_vm.isPassengerSameAsBooker)},on:{"change":[function($event){var $$a=_vm.isPassengerSameAsBooker,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isPassengerSameAsBooker=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isPassengerSameAsBooker=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isPassengerSameAsBooker=$$c}},function($event){return _vm.copyBooker()}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle text-filter"},[_vm._v("\n                    Same as Booking Contact Information\n                  ")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.useCompanySelection)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Company")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.reservationRequest.passengers.$each[0]
                              .companyId.$error,
                        },attrs:{"placeholder":"","label":"name","options":_vm.companies,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; },"disabled":_vm.isPassengerSameAsBooker},on:{"input":_vm.getPassengersByCompanyId},model:{value:(_vm.reservationRequest.passengers[0].companyId),callback:function ($$v) {_vm.$set(_vm.reservationRequest.passengers[0], "companyId", $$v)},expression:"reservationRequest.passengers[0].companyId"}}),_vm._v(" "),(
                          _vm.isSubmitted &&
                          !_vm.$v.reservationRequest.passengers.$each[0].companyId
                            .required
                        )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                        Company is required\n                      ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.useCustomerSelection)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Customer")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.reservationRequest.passengers.$each[0]
                              .customerId.$error,
                        },attrs:{"placeholder":"","label":"label","options":_vm.customersAsPassenger,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; },"disabled":_vm.isPassengerSameAsBooker ||
                          !_vm.reservationRequest.passengers[0].companyId},model:{value:(_vm.reservationRequest.passengers[0].customerId),callback:function ($$v) {_vm.$set(_vm.reservationRequest.passengers[0], "customerId", $$v)},expression:"reservationRequest.passengers[0].customerId"}}),_vm._v(" "),(
                          _vm.isSubmitted &&
                          !_vm.$v.reservationRequest.passengers.$each[0]
                            .customerId.required
                        )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                        Customer is required\n                      ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(
                        _vm.reservationRequest.passengers[0].customerId &&
                        _vm.isUseFreetext(
                          _vm.reservationRequest.passengers[0].customerId
                        )
                      )?[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Select Title")]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},_vm._l((_vm.personTitles),function(item,index){return _c('label',{key:index,staticClass:"btn",class:{
                              active:
                                _vm.reservationRequest.passengers[0].title ===
                                item.value,
                            },attrs:{"disabled":_vm.isPassengerSameAsBooker},on:{"click":function($event){_vm.reservationRequest.passengers[0].title =
                                item.value}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reservationRequest.passengers[0].title),expression:"reservationRequest.passengers[0].title"}],attrs:{"type":"radio","name":"booker_title","autocomplete":"off","disabled":_vm.isPassengerSameAsBooker},domProps:{"value":item.value,"checked":_vm.reservationRequest.passengers[0].title ===
                                item.value,"checked":_vm._q(_vm.reservationRequest.passengers[0].title,item.value)},on:{"change":function($event){return _vm.$set(_vm.reservationRequest.passengers[0], "title", item.value)}}}),_vm._v("\n                            "+_vm._s(item.text)+"\n                          ")])}),0),_vm._v(" "),(
                            _vm.isSubmitted &&
                            !_vm.$v.reservationRequest.passengers.$each[0].title
                              .required
                          )?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                          Title is required\n                        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Full Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reservationRequest.passengers[0].fullName),expression:"reservationRequest.passengers[0].fullName"}],staticClass:"form-control alphabets-only",class:{
                            'field-error':
                              _vm.isSubmitted &&
                              !_vm.$v.reservationRequest.passengers.$each[0]
                                .fullName.required,
                          },attrs:{"type":"text","maxlength":"150","disabled":_vm.isPassengerSameAsBooker},domProps:{"value":(_vm.reservationRequest.passengers[0].fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reservationRequest.passengers[0], "fullName", $event.target.value)}}}),_vm._v(" "),(
                            _vm.isSubmitted &&
                            !_vm.$v.reservationRequest.passengers.$each[0]
                              .fullName.required
                          )?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                          Fullname is required\n                        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Phone")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                                'field-error':
                                  _vm.isSubmitted &&
                                  !_vm.$v.reservationRequest.passengers.$each[0]
                                    .phoneCode.required,
                              },attrs:{"placeholder":"","label":"label","options":_vm.phoneCodes,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.dial; },"disabled":_vm.isPassengerSameAsBooker},scopedSlots:_vm._u([{key:"search",fn:function(ref){
                              var attributes = ref.attributes;
                              var events = ref.events;
return [_c('input',_vm._g(_vm._b({staticClass:"vs__search",attrs:{"name":"booker_phoneCode"}},'input',attributes,false),events))]}},{key:"option",fn:function(option){return [_c('div',{staticClass:"phone-wrapper"},[_c('div',{staticClass:"phone-icon",class:option.icon}),_vm._v(" "),_c('div',{staticClass:"phone-text"},[_vm._v("\n                                    "+_vm._s(option.iata)+"\n                                  ")])])]}}],null,false,553913263),model:{value:(
                                _vm.reservationRequest.passengers[0].phoneCode
                              ),callback:function ($$v) {_vm.$set(_vm.reservationRequest.passengers[0], "phoneCode", $$v)},expression:"\n                                reservationRequest.passengers[0].phoneCode\n                              "}}),_vm._v(" "),(
                                _vm.isSubmitted &&
                                !_vm.$v.reservationRequest.passengers.$each[0]
                                  .phoneCode.required
                              )?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                              Phone code is required\n                            ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-8",staticStyle:{"padding-left":"0","padding-top":"30px"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.reservationRequest.passengers[0].phoneNumber
                              ),expression:"\n                                reservationRequest.passengers[0].phoneNumber\n                              "}],staticClass:"form-control numbers-only",class:{
                                'field-error':
                                  _vm.isSubmitted &&
                                  !_vm.$v.reservationRequest.passengers.$each[0]
                                    .phoneNumber.required,
                              },attrs:{"type":"text","name":"booker_phoneNumber","disabled":_vm.isPassengerSameAsBooker},domProps:{"value":(
                                _vm.reservationRequest.passengers[0].phoneNumber
                              )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reservationRequest.passengers[0], "phoneNumber", $event.target.value)}}}),_vm._v(" "),(
                                _vm.isSubmitted &&
                                !_vm.$v.reservationRequest.passengers.$each[0]
                                  .phoneNumber.required
                              )?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                              Phone number is required\n                            ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reservationRequest.passengers[0].email),expression:"reservationRequest.passengers[0].email"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted &&
                              !_vm.$v.reservationRequest.passengers.$each[0].email
                                .required,
                          },attrs:{"placeholder":"e.g youremail@gmail.com","maxlength":"100","disabled":_vm.isPassengerSameAsBooker},domProps:{"value":(_vm.reservationRequest.passengers[0].email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reservationRequest.passengers[0], "email", $event.target.value)}}}),_vm._v(" "),(
                            _vm.isSubmitted &&
                            !_vm.$v.reservationRequest.passengers.$each[0].email
                              .required
                          )?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                          Email is required\n                        ")]):_vm._e(),_vm._v(" "),(
                            _vm.isSubmitted &&
                            _vm.$v.reservationRequest.passengers.$each[0].email
                              .required &&
                            !_vm.$v.reservationRequest.passengers.$each[0].email
                              .email
                          )?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                          Email is invalid\n                        ")]):_vm._e()])]:_vm._e()],2)])]),_vm._v(" "),(_vm.hasAncillary)?_c('div',{staticClass:"box-addons",staticStyle:{"padding-top":"20px"}},[_c('div',{staticClass:"panel-group",attrs:{"id":"accordion"}},[_c('div',{staticClass:"panel panel-default"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":"collapse1"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"table-p10"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover mtz"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.ancillaries),function(item,index){return _c('tr',{key:item.masterClassAncillaryId},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v("\n                                    "+_vm._s(item.currencyCode)+"\n                                    "+_vm._s(_vm.printMoney(item.rate))+"\n                                  ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticClass:"form-control numbers-only",attrs:{"type":"number","min":"0"},domProps:{"value":(item.quantity)},on:{"change":function($event){return _vm.onChangeAncillary(item)},"keyup":function($event){return _vm.onChangeAncillary(item)},"blur":function($event){return _vm.onBlurAncillary(item)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity", $event.target.value)}}})])])}),0)])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.isAirportTransfer)?_c('div',{staticClass:"passenger-information"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Airline")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                              'field-error':
                                _vm.isSubmitted &&
                                _vm.$v.reservationRequest.departureAirline.$error,
                            },attrs:{"placeholder":"Select an airline","label":"label","options":_vm.orderedAirlines,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.iataCode; }},model:{value:(_vm.reservationRequest.departureAirline),callback:function ($$v) {_vm.$set(_vm.reservationRequest, "departureAirline", $$v)},expression:"reservationRequest.departureAirline"}}),_vm._v(" "),(
                              _vm.isSubmitted &&
                              !_vm.$v.reservationRequest.departureAirline.required
                            )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Airline is required")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Flight/Tail No.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reservationRequest.departureFlightNumber),expression:"reservationRequest.departureFlightNumber"}],staticClass:"form-control alphabets-numbers-only",class:{
                              'field-error':
                                _vm.isSubmitted &&
                                _vm.$v.reservationRequest.departureFlightNumber
                                  .$error,
                            },attrs:{"type":"text","name":"departure_flightNumber","autocomplete":"off"},domProps:{"value":(_vm.reservationRequest.departureFlightNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reservationRequest, "departureFlightNumber", $event.target.value)}}}),_vm._v(" "),(
                              _vm.isSubmitted &&
                              _vm.$v.reservationRequest.departureFlightNumber
                                .$error
                            )?_c('div',[(
                                !_vm.$v.reservationRequest.departureFlightNumber
                                  .required
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Flight Number is invalid")]):_vm._e(),_vm._v(" "),(
                                !_vm.$v.reservationRequest.departureFlightNumber
                                  .maxLength
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Flight Number must be less than\n                              "+_vm._s(_vm.$v.reservationRequest.departureFlightNumber
                                  .$params.maxLength.max)+"\n                              characters")]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Notes to Driver")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reservationRequest.notes),expression:"reservationRequest.notes"}],staticClass:"form-control",attrs:{"rows":"5","name":"notes"},domProps:{"value":(_vm.reservationRequest.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reservationRequest, "notes", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"text-right word-count"},[_vm._v("\n                        "+_vm._s(_vm.reservationRequest.notes.length)+" / 400\n                        characters\n                      ")]),_vm._v(" "),(
                          _vm.isSubmitted &&
                          !_vm.$v.reservationRequest.notes.maxLength
                        )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Notes must be less than\n                        "+_vm._s(_vm.$v.reservationRequest.notes.$params.maxLength.max)+"\n                        characters")]):_vm._e()])])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mt-20",attrs:{"type":"submit"}},[_vm._v("\n                Proceed to Payment\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5 postick"},[_c('div',{staticClass:"price-detail-header"},[_c('div',{staticClass:"grand-total"},[_c('table',{staticClass:"table table-amount mt-5"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-left --green"},[_vm._v("Amount to Pay")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.vehicle.currencyCode)+" "+_vm._s(_vm.printMoney(_vm.grandTotal))+"\n                    ")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("Base")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.printMoney(_vm.vehicle.baseFare))+"\n                    ")])]),_vm._v(" "),(_vm.isSelfDrive)?_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("Insurance")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.printMoney(_vm.totalInsurance))+"\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.isSelfDrive)?_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('ul',{staticClass:"table-list"},_vm._l((_vm.vehicle.selfDriveRate.items),function(insurance){return _c('li',{key:insurance.code},[_vm._v("\n                          "+_vm._s(insurance.name)+" ("+_vm._s(insurance.code)+")\n                          "),_c('span',{staticClass:"value"},[_vm._v("\n                            "+_vm._s(_vm.printMoney(insurance.rate))+"\n                          ")])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.hasSurcharge)?_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("Surcharge")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.printMoney(_vm.vehicle.surcharge))+"\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.isAncillarySelected)?_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("Ancillary")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.printMoney(_vm.totalAncillary))+"\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.isAncillarySelected)?_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('ul',{staticClass:"table-list"},_vm._l((_vm.selectedAncillaries),function(ancillary,index){return _c('li',{key:index},[_vm._v("\n                          "+_vm._s(ancillary.name)),_c('span',[_vm._v("x"+_vm._s(ancillary.quantity))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.printMoney(ancillary.subtotal)))])])}),0)])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"reservation-summary--small"},[_c('div',{staticClass:"dropandpickup cRow"},[_c('div',{staticClass:"col-sm-6 plz"},[_c('div',{staticClass:"location-pick-up"},[_vm._v("\n                  "+_vm._s(_vm.searchParameterPickUpLocation)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"row mt-10"},[_c('div',{staticClass:"col-sm-5 prz"},[_c('div',{staticClass:"rent-date"},[_vm._v(_vm._s(_vm.shortPickUpDate))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7 text-right"},[_c('div',{staticClass:"rent-time"},[_c('i',{staticClass:"ic-time"}),_vm._v("\n                      "+_vm._s(_vm.shortPickUpTime)+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 prz divider-left"},[_c('div',{staticClass:"location-drop-off text-right"},[_vm._v("\n                  "+_vm._s(_vm.searchParameterDropOffLocation)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"row mt-10"},[_c('div',{staticClass:"col-sm-5 prz"},[_c('div',{staticClass:"rent-date"},[_vm._v(_vm._s(_vm.shortDropOffDate))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7 text-right"},[_c('div',{staticClass:"rent-time"},[_c('i',{staticClass:"ic-time"}),_vm._v("\n                      "+_vm._s(_vm.shortDropOffTime)+"\n                    ")])])])])]),_vm._v(" "),(_vm.searchParameter.serviceType === 'Rental')?_c('div',{staticClass:"overlimit-info"},[_vm._m(5)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cRow"},[(_vm.searchParameter.mode === 'OnDemand')?[_c('div',{staticClass:"col-sm-7"},[_c('img',{staticClass:"cars-image",attrs:{"src":_vm.vehicle.imageUri,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"provider-img"},[_c('img',{attrs:{"src":_vm.vehicle.providers[0].imageUri,"alt":""}})])])]:[_c('div',{staticClass:"col-sm-12"},[_c('img',{staticClass:"cars-image",attrs:{"src":_vm.vehicle.imageUri,"alt":""}})])]],2),_vm._v(" "),_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"table-legend mt-15"},[_c('ul',[(_vm.isAirportTransfer)?_c('li',[_c('i',{staticClass:"ic-flight-icon"}),_vm._v("Airport Transfer\n                  ")]):_c('li',[_c('i',{staticClass:"ic-time"}),_vm._v("Hourly Booking")])])]),_vm._v(" "),_c('div',[(_vm.hasVehicleName)?_c('div',[_c('span',{staticClass:"cars-brand"},[_vm._v("\n                    "+_vm._s(_vm.vehicle.factoryName)+" "+_vm._s(_vm.vehicle.brandName)+"\n                  ")]),_vm._v("\n                  or similar\n                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"type-car"},[_vm._v(_vm._s(_vm.vehicle.className)+" Class")]),_vm._v(" "),_c('div',{staticClass:"type-car hidden",class:{
                    'self-drive': _vm.isSelfDrive,
                    'with-driver': !_vm.isSelfDrive,
                  }}),_vm._v(" "),(
                    _vm.hasPaxCapacity ||
                    _vm.hasLargeBaggageCapacity ||
                    _vm.hasSmallBaggageCapacity
                  )?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.hasPaxCapacity)?_c('div',{staticClass:"capacity-seat"},[_vm._v("\n                      Max. Passenger "+_vm._s(_vm.vehicle.feature.paxCapacity)+"\n                    ")]):_vm._e()])]):_vm._e()])]),_vm._v(" "),(_vm.searchParameter.mode === 'OnDemand')?_c('div',{staticClass:"provider-box cRowen-col"},[_c('div',{staticClass:"provider-name"},[_vm._v(_vm._s(_vm.vehicle.providers[0].name))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"reservation-button"},[_c('button',{staticClass:"btn btn-block btn-nobg",on:{"click":function($event){return _vm.refresh()}}},[_vm._v("\n                Change Car\n              ")])])])])])])]):_vm._e(),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_vm._v("\n                  Booker information\n                  "),_c('span',{staticClass:"--blue"},[_vm._v("Please fill all information below.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_vm._v("\n                  Passenger information\n                  "),_c('span',[_vm._v("Please fill all information below.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"data-toggle":"collapse","data-parent":"#accordion","href":"#collapse1"}},[_vm._v("\n                          + Extras\n                        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Item Name")]),_vm._v(" "),_c('th',[_vm._v("Price")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"125px"}},[_vm._v("\n                                    Qty\n                                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_vm._v("\n                  Pick-up Details\n                  "),_c('span',[_vm._v("Please fill all information below.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-info"},[_c('span',{staticClass:"info-icon mhide"}),_vm._v("Returns more than one\n                hour will be charged an overtime fee.\n              ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/47.488b14de23e0cb3fcb8b.js